import { ApiTagTypes, BasePracticeProspect, ProspectCategory, ProspectType } from '../../types';
import { apiSlice } from '../api.services';

type getProspectsForSelectParams = {
  categories?: ProspectCategory[];
  types?: ProspectType[];
  includeJobTitle?: boolean;
  includeAssociatedPhoneNumber?: boolean;
  orgId?: string;
};

type GetProspectsForSelectResponse = {
  data: {
    prospects: BasePracticeProspect[];
  };
};

const enhancedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPracticeProspectsForSelect: builder.query<BasePracticeProspect[], getProspectsForSelectParams>({
      query: (params) => ({
        url: '/prospects/select',
        params,
      }),
      transformResponse: (response: GetProspectsForSelectResponse) => response.data.prospects,
      providesTags: [ApiTagTypes.PROSPECTS_FOR_SELECT],
    }),
  }),
});

export const { useGetPracticeProspectsForSelectQuery } = enhancedApiSlice;
